import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import { Text } from 'foundations-components/components/Text';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValidTriggerCheckValidationResultLabel = ({
  validationResult,
  flowRevision
}) => {
  const validTriggerCheckLabel = (() => {
    switch (validationResult.enrollmentCategory) {
      case 'BULK_ENROLLMENT_LIST':
      case 'ENROLLMENT_LIST_MEMBERSHIP':
        {
          const hasMostRecentlyJoinedEnrollmentListWithBulk = 'hasMostRecentlyJoinedEnrollmentListWithBulk' in validationResult && validationResult.hasMostRecentlyJoinedEnrollmentListWithBulk;
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.passed' : validationResult.enrollmentList ? hasMostRecentlyJoinedEnrollmentListWithBulk ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.failed.joinedEnrollmentListWithBulk' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.failed.doesNotMeetCriteria' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.ENROLLMENT_LIST_EVALUATION.label.failed.noEnrollmentList'
            })
          });
        }
      case 'UNIFIED_EVENT_TRIGGER':
        {
          const isUsingEventEnrollment = flowRevision.flow.enrollmentTrigger === 'EVENT';
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: isUsingEventEnrollment ? validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.label.passed.enrollment' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.label.failed.enrollment' : validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.label.passed.reEnrollment' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.UNIFIED_EVENT_TRIGGER.label.failed.reEnrollment'
            })
          });
        }
      case 'CLASSIC_REENROLLMENT_TRIGGER':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.label.passed' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.label.failed'
            })
          });
        }
      case 'LIST_MEMBERSHIP_EVENT_TRIGGER':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.label.passed' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.LIST_MEMBERSHIP_EVENT_TRIGGER.label.failed'
            })
          });
        }
      case 'PERSISTED_REENROLLMENT_LIST_MEMBERSHIP':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.label.passed' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.PERSISTED_REENROLLMENT_LIST_MEMBERSHIP.label.failed'
            })
          });
        }
      case 'MANUAL_ENROLLMENT':
        {
          return /*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginInlineStart: "200",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: validationResult.enrollmentAllowed ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.MANUAL_ENROLLMENT.label.passed' : ''
            })
          });
        }
      default:
        {
          Raven.captureMessage('Unexpected valid trigger `enrollmentCategory`', {
            extra: {
              enrollmentCategory: validationResult.enrollmentCategory
            }
          });
          return null;
        }
    }
  })();
  return /*#__PURE__*/_jsxs(UIFlex, {
    children: [/*#__PURE__*/_jsx(ValidationLabelIcon, {
      status: validationResult.enrollmentAllowed ? 'PASSED' : 'FAILED'
    }), /*#__PURE__*/_jsx("div", {
      style: {
        display: 'inline-block',
        position: 'relative',
        top: 2
      },
      children: validTriggerCheckLabel
    })]
  });
};
export default ValidTriggerCheckValidationResultLabel;